import { render, staticRenderFns } from "./MessageIntegration.vue?vue&type=template&id=fb108146&functional=true"
import script from "./MessageIntegration.vue?vue&type=script&lang=js"
export * from "./MessageIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports